import { render, staticRenderFns } from "./IconIndentRight.vue?vue&type=template&id=08368100&"
import script from "./IconIndentRight.vue?vue&type=script&lang=js&"
export * from "./IconIndentRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports